<template>
  <v-card class="mb-2">
    <v-row class="pa-2">
      Key: {{ v_key }}
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('onDelete')">
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </v-row>
    <v-row class="align-center">
      <v-col md="3">
        Name:
      </v-col>
      <v-col md="9">
        <c-input :value.sync="v_value.name" class="crx-box-input"></c-input>
      </v-col>
    </v-row>
    <v-row class="align-center">
      <v-col md="3">
        Type:
      </v-col>
      <v-col md="9">
        <v-select hide-details :items="types" v-model="v_value.type" solo class="crx-box-input"></v-select>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  props: {
    v_value: null,
    v_key: null
  },
  data () {
    return {
      types: ['boolean', 'object', 'array']
    }
  }
}
</script>